import { STATUS } from "@/lib/checkins";

export function StatusChip({ status, testId, small = false }) {
  const s = STATUS[status] || STATUS.not_assessable;
  const Icon = s.icon;
  return (
    <span
      className={`inline-flex items-center gap-1 rounded-full border font-semibold ${s.chip} ${small ? "px-1.5 py-0.5 text-2xs" : "px-2.5 py-1 text-sm"}`}
      data-testid={testId}
    >
      <Icon className={small ? "h-3 w-3" : "h-4 w-4"} aria-hidden="true" />
      {s.label}
    </span>
  );
}

// One domain result: dose, status label + icon, reason, optional next step.
export function StatusCard({ card, large = false }) {
  const s = STATUS[card.status] || STATUS.not_assessable;
  return (
    <div className="relative overflow-hidden rounded-xl border border-zinc-200 bg-white p-4 pl-5" data-testid={`status-card-${card.code}`}>
      <span className={`absolute inset-y-0 left-0 w-1.5 ${s.bar}`} aria-hidden="true" />
      <div className="flex flex-wrap items-start justify-between gap-2">
        <h3 className={`font-display font-semibold text-zinc-950 ${large ? "text-lg" : "text-base"}`}>{card.label}</h3>
        <StatusChip status={card.status} testId={`status-card-${card.code}-status`} small={!large} />
      </div>
      {card.dose && <p className={`mt-1 font-mono-num text-zinc-600 ${large ? "text-base" : "text-sm"}`}>{card.dose}</p>}
      {card.reason && <p className={`mt-2 text-zinc-800 ${large ? "text-base" : "text-sm"}`}>{card.reason}</p>}
      {card.next_step && (
        <p className={`mt-2 text-zinc-700 ${large ? "text-base" : "text-sm"}`}>
          <span className="font-semibold">Next step: </span>{card.next_step}
        </p>
      )}
      {(card.safety_override || card.overridden) && (
        <p className="mt-2 text-xs font-medium text-zinc-500">
          {card.safety_override ? "Set by a safety response" : "Reviewed by your exercise team"}
        </p>
      )}
    </div>
  );
}
